import React, { useMemo } from 'react';
import Loading from 'react-simple-loading';

import AnchorLiveFeedPlayerControls from './AnchorLiveFeedPlayerControls/AnchorLiveFeedPlayerControls';
import TulumRealityShowStore from '../../../store/TulumRealityShowStore';
import { observer } from 'mobx-react';


const StreamViewPlayer = React.lazy(() => import('../../StreamViewPlayer/StreamViewPlayer'));
const HLSStreamViewPlayer = React.lazy(() => import('../../StreamViewPlayer/HLSStreamViewPlayer'));

function StreamPlayer(props) {
  const {
    anchorUsername,
    shouldStart,
    broadcasterClosedSession,
    shouldHideVolumeRange,
    spotlighterClosedSession,
    hasStreamViews,
    isTulumRealityShow,
    anchorVideoUrl,
    toggleStreamLoading,
    user,
    orientation,
    onAllowStreamChangeOnError,
    streamErrorMessage,
    shouldShowSubscriveOverlay,
    isInGroupShow,
    isBanned,
    shouldDisplayPlayer,
    toggleFullscreen,
    onLiveSessionEnd,
    handleHLSError,
    clearLoadRetries,
  } = props;

  const shouldShowStream = useMemo(() =>
    !shouldShowSubscriveOverlay && !isInGroupShow && !isBanned && shouldDisplayPlayer,
    [isBanned, isInGroupShow, shouldDisplayPlayer, shouldShowSubscriveOverlay]);

  const handleStreamEvent = (data, error) => {
    if (!error) {
      TulumRealityShowStore.setIsStreamUnavailable(false);
    } else {
      TulumRealityShowStore.setIsStreamUnavailable(true);
    }
  };

  const displayOfflineOverlay = () => {
    clearLoadRetries();

    return (
      <div className="anchor-ended-session-overlay">
        <p>{streamErrorMessage}</p>
      </div>
    );
  };

  if (!streamErrorMessage && !shouldShowStream) {
    return null;
  }

  if (streamErrorMessage) {
    return displayOfflineOverlay();
  }

  const StreamComponent = isTulumRealityShow ? HLSStreamViewPlayer : StreamViewPlayer;

  if (shouldShowStream) {

    return (
      <React.Suspense fallback={null}>
        <StreamComponent
          anchorUsername={anchorUsername}
          autoplay={shouldStart}
          controls={({
            muted,
            volume,
            playStream,
            showPlay,
            onVolumeChange,
            onMuteChange,
            disableMute,
          }) => (
            <AnchorLiveFeedPlayerControls
              broadcasterClosedSession={broadcasterClosedSession}
              disableMute={disableMute}
              mutePlayer={onMuteChange}
              muted={muted}
              playVideo={playStream}
              shouldHideVolumeRange={shouldHideVolumeRange}
              showPlay={showPlay}
              spotlighterClosedSession={spotlighterClosedSession}
              toggleFullscreen={toggleFullscreen}
              volume={volume}
              onVolumeChange={onVolumeChange}
            />
          )}
          hasStreamViews={hasStreamViews}
          isTulumRealityShow={isTulumRealityShow}
          loadingOverlay={(loading) =>
            loading &&
            !broadcasterClosedSession && !spotlighterClosedSession && (
              <div className="anchor-live-feed-loading">
                <Loading color="white" />
              </div>
            )
          }
          streamData={anchorVideoUrl}
          toggleStreamLoading={toggleStreamLoading}
          user={user}
          videoClass={`anchor-live-feed-video anchor-live-feed-video--${orientation}`}
          videoId={'myvideo'}
          onAllowStreamChangeOnError={onAllowStreamChangeOnError}
          onHLSError={handleHLSError}
          handleStreamEvent={handleStreamEvent}
          onLiveSessionEnd={onLiveSessionEnd}
        />
      </React.Suspense>
    );
  }
}

export default observer(StreamPlayer);
